export enum BlocÉtat {
  FAIT = 'Fait',
  A_FAIRE = 'AFaire',
  EN_COURS = 'EnCours',
}
